import React from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { Button } from 'dui/button'
import { useAuthApi, useAuthInfo } from 'authy-react'
import { Avatar, AvatarFallback } from 'dui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'dui/dropdown-menu'
import { PersonIcon } from '@radix-ui/react-icons'

import { cn } from '@/lib/utils'

const AppLayout: React.FC = () => {
  const { service } = useAuthApi()
  const navigate = useNavigate()
  const { userInfo } = useAuthInfo()

  const initials =
    (userInfo?.name?.first?.[0]?.toUpperCase() ?? '') + (userInfo?.name?.last?.[0]?.toUpperCase() ?? '')

  return (
    <div className="h-screen flex flex-col bg-background text-foreground overflow-hidden">
      <header className="flex items-center px-6 py-4 border-b border-border bg-card shrink-0 gap-6">
        <h1 className="text-lg font-semibold whitespace-nowrap">Jasna Admin Panel</h1>

        <div className="flex flex-1 items-center justify-center">
          <nav className="flex gap-6 text-sm">
            <NavLink
              to="/"
              className={({ isActive }) =>
                cn(
                  'text-muted-foreground hover:text-primary transition-colors',
                  isActive && 'text-primary font-semibold',
                )
              }
            >
              Kontrolni panel
            </NavLink>
            <NavLink
              to="/questions"
              className={({ isActive }) =>
                cn(
                  'text-muted-foreground hover:text-primary transition-colors',
                  isActive && 'text-primary font-semibold',
                )
              }
            >
              Baza znanja
            </NavLink>
            <NavLink
              to="/unanswered"
              className={({ isActive }) =>
                cn(
                  'text-muted-foreground hover:text-primary transition-colors',
                  isActive && 'text-primary font-semibold',
                )
              }
            >
              Neodgovorena pitanja
            </NavLink>
          </nav>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="secondary" size="icon" className="rounded-full">
              <Avatar className="size-8">
                <AvatarFallback>{initials || <PersonIcon />}</AvatarFallback>
              </Avatar>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>
              {`${userInfo?.name?.first ?? ''} ${userInfo?.name?.last ?? ''}`.trim() ||
                userInfo?.username?.trim() ||
                userInfo?.email ||
                'My account'}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="cursor-pointer" onClick={() => navigate('/demo')}>
              Demo
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="cursor-pointer text-red-500" onClick={() => service.signOut()}>
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </header>

      <main className="flex-1 overflow-y-auto p-6">
        <Outlet />
      </main>
    </div>
  )
}

export default AppLayout
